import { ProductRule } from '../types/productTypes'

export const productRequiresWiserHub = (productNo: string | null, rules: readonly ProductRule[]) => {
  if (productNo === null) {
    return false
  }

  const wiserRuleForItem = rules.find(rule => {
    return rule.ruleType === 'RequiresWiserHub'
       && rule.products.includes(productNo)
  })

  return wiserRuleForItem !== undefined
}

export default productRequiresWiserHub